import axios, { AxiosResponse } from 'axios';
import { Match } from 'shared/types/Match';

export const fetchMatch = (id: string): Promise<AxiosResponse<Match>> =>
  axios.get<Match>(`/api/match/${id}`);
